export default "__VITE_ASSET__avw3sHiQ__"